import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Send.svg",
  "use": "Send.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Send.svg\"><path d=\"M50.09,8.2082a1.3053,1.3053,0,0,1,1.9361,1.3752L44.5142,48.7267A1.5761,1.5761,0,0,1,42.4466,49.91L30.7588,45.5335l-4.9822,9.9626a.9269.9269,0,0,1-1.7561-.4144V44.4238a4.1441,4.1441,0,0,1,.8881-2.513c.6483-.7407,19.1018-24.89,19.1018-24.89S19.2938,39.108,18.3217,39.8953a3.0427,3.0427,0,0,1-2.9231.5609L4.891,36.863A1.2977,1.2977,0,0,1,4.6638,34.51Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol